
export const fetchApiVersion = () => {

    const version = process.env.REACT_APP_API_VERSION;
    return version === undefined ? "" : version;
}